/* eslint-disable object-curly-newline,no-unused-vars */
import { Badge, IconButton, ListItem } from '@mui/material'
import { useMemoRef } from '@platform/react/hook'
import Icon from 'ui/Element/Icon'

/**
 * Simple, ACL-controlled {@link Icon} meant to be used in
 * the application's {@link Toolbar}.
 *
 * @param {Object} child            various options for the icon
 * @param {Object} [options]        additional options
 * @param {Object} [notification]   optional notification count
 * @returns {JSX.Element}
 */
const AclSimpleIcon = ({ child, options, notification }) => {
  const {
    key,
    active,
    disabled,
    icon: iconProps,
    color,
    classes,
    context,
    route: { module, action },
  } = child

  const icon = <Icon
    source={iconProps}
    color={color}
  />

  return (
    <ListItem
      key={key}
      className={`${classes.toolbarLinksItem}`}
    >
      <IconButton
        size={'small'}
        disabled={disabled || active}
        href={`/#/${context}/${module}/${action}`}
      >
        {notification?.count > 0
          ? (<Badge
            badgeContent={notification.count}
            classes={{ badge: classes.toolbarLinksItemBadge }}
          >
            {icon}
          </Badge>)
          : icon
        }
      </IconButton>
    </ListItem>
  )
}

export default useMemoRef(AclSimpleIcon)
